// // components/userCabinet/CabinetTilesDynamic.jsx
// import { useEffect, useMemo, useState } from "react";
// import { auth, db } from "../../firebase";
// import { doc, getDoc } from "firebase/firestore";
// import { subscribeCabinetTiles } from "../../services/cabinetTilesService";
// import css from "../catalog/catalog.module.css"; // ті самі стилі!

// // нормалізація способу
// const normPm = (pm) => (pm === "card" ? "acquiring" : pm || "invoice");
// const pmLabel = (pm) =>
//   ({ invoice: "Рахунок", acquiring: "Еквайринг" }[pm] || "—");

// // t.me deep link
// function tgLink(username, text) {
//   if (!username) return "#";
//   const u = username.replace(/^@/, "");
//   return `https://t.me/${u}?text=${encodeURIComponent(text || "")}`;
// }

// // simple template fill
// function fill(tpl = "", vars = {}) {
//   return tpl.replace(/{{\s*(\w+)\s*}}/g, (_, k) => `${vars[k] ?? ""}`);
// }

// export default function CabinetTilesDynamic() {
//   const [cfg, setCfg] = useState(null);
//   const [userMeta, setUserMeta] = useState({
//     paymentMethod: "invoice",
//     displayName: "",
//   });

//   useEffect(() => {
//     const unsub = subscribeCabinetTiles(setCfg);
//     return () => unsub && unsub();
//   }, []);

//   useEffect(() => {
//     const uid = auth?.currentUser?.uid;
//     if (!uid) return;
//     getDoc(doc(db, "users", uid)).then((s) => {
//       const d = s.data() || {};
//       // дефолтний тип — рахунок (як домовлялися)
//       setUserMeta({
//         paymentMethod: d.paymentMethod || "invoice",
//         displayName: d.displayName || "",
//       });
//     });
//   }, []);

//   if (!cfg) return null;

//   const pm = normPm(userMeta.paymentMethod);
//   const opposite = pm === "invoice" ? "acquiring" : "invoice";
//   const nameOrId =
//     userMeta.displayName ||
//     auth?.currentUser?.email ||
//     auth?.currentUser?.uid ||
//     "Клієнт";

//   // Тексти і лінки — тільки з адмінки:
//   const tile1Text =
//     pm === "invoice" ? cfg?.tile1?.invoiceText : cfg?.tile1?.acquiringText;

//   const tile2Label =
//     pm === "invoice" ? cfg?.tile2?.invoiceCta : cfg?.tile2?.acquiringCta;

//   const tile2Text = fill(cfg?.tile2?.template, {
//     name: nameOrId,
//     current: pmLabel(pm),
//     desired: pmLabel(opposite),
//   });
//   const tile2Href = tgLink(cfg?.tile2?.telegram, tile2Text);

//   const tile3Label = cfg?.tile3?.label;
//   const tile3Href = tgLink(cfg?.tile3?.telegram, cfg?.tile3?.template || "");

//   const tile4Label = cfg?.tile4?.label;
//   const tile4Href = cfg?.tile4?.url || "#";

//   const tile5Title = cfg?.tile5?.title;
//   const tile5Text = cfg?.tile5?.text;
//   const tile5CtaText = cfg?.tile5?.ctaText;
//   const tile5CtaUrl = cfg?.tile5?.ctaUrl;

//   const hasContracts =
//     cfg?.contracts?.sale?.url ||
//     cfg?.contracts?.consignment?.url ||
//     cfg?.contracts?.dropshipping?.url;

//   return (
//     <div className={css.discountAndACWrapp}>
//       {/* Перший ряд — 2 плашки */}
//       <div className={css.discountAndACWrappFirst}>
//         {/* 1) Інфо про поточний спосіб оплати */}
//         <div className={css.freeDelyvery} role="button" tabIndex={0}>
//           {tile1Text || `Ваш тип оплати — ${pmLabel(pm)}`}
//         </div>

//         {/* 2) Заявка на зміну способу */}
//         <a
//           className={css.procentSale}
//           href={tile2Href}
//           target="_blank"
//           rel="noopener"
//         >
//           {tile2Label || `Заявка на зміну: ${pmLabel(opposite)}`}
//         </a>
//       </div>

//       {/* Другий ряд — 3 плашки */}
//       <div className={css.discountAndACWrappSecond}>
//         {/* 3) Порекомендуйте видати книгу */}
//         <a
//           className={css.discountForNine}
//           href={tile3Href}
//           target="_blank"
//           rel="noopener"
//         >
//           {tile3Label || "Порекомендуйте видати книгу"}
//         </a>

//         {/* 4) Скрипти продаж (YouTube) */}
//         <a
//           className={css.krohmalPackeg}
//           href={tile4Href}
//           target="_blank"
//           rel="noopener"
//         >
//           {tile4Label || "Скрипти продаж книжок"}
//         </a>

//         {/* 5) Інформаційна + за наявності кнопки */}
//         <div className={css.smakolukForUser}>
//           <div style={{ fontWeight: 700, marginBottom: 6 }}>
//             {tile5Title || "Інформація"}
//           </div>
//           <div style={{ marginBottom: 8 }}>
//             {tile5Text || "Тут може бути ваш текст з адмінки."}
//           </div>
//           {tile5CtaUrl && tile5CtaText && (
//             <a
//               href={tile5CtaUrl}
//               target="_blank"
//               rel="noopener"
//               style={{
//                 display: "inline-block",
//                 padding: "6px 10px",
//                 borderRadius: 10,
//                 border: "1px solid #3e51c1",
//                 background: "#3e51c1",
//                 color: "#fff",
//                 textDecoration: "none",
//               }}
//             >
//               {tile5CtaText}
//             </a>
//           )}
//           {/* Додатково: якщо є договори — покажемо маленький список посилань */}
//           {hasContracts && (
//             <div style={{ marginTop: 8, fontSize: 13 }}>
//               <div style={{ fontWeight: 600, marginBottom: 4 }}>Договори:</div>
//               <ul style={{ margin: 0, paddingLeft: 18 }}>
//                 {cfg?.contracts?.sale?.url && (
//                   <li>
//                     <a
//                       href={cfg.contracts.sale.url}
//                       target="_blank"
//                       rel="noopener"
//                     >
//                       Продаж ({cfg.contracts.sale.fileName || "PDF"})
//                     </a>
//                   </li>
//                 )}
//                 {cfg?.contracts?.consignment?.url && (
//                   <li>
//                     <a
//                       href={cfg.contracts.consignment.url}
//                       target="_blank"
//                       rel="noopener"
//                     >
//                       Реалізація ({cfg.contracts.consignment.fileName || "PDF"})
//                     </a>
//                   </li>
//                 )}
//                 {cfg?.contracts?.dropshipping?.url && (
//                   <li>
//                     <a
//                       href={cfg.contracts.dropshipping.url}
//                       target="_blank"
//                       rel="noopener"
//                     >
//                       Дропшипінг ({cfg.contracts.dropshipping.fileName || "PDF"}
//                       )
//                     </a>
//                   </li>
//                 )}
//               </ul>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }
// components/userCabinet/CabinetTilesDynamic.jsx
import { useEffect, useState } from "react";
import { auth, db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import { subscribeCabinetTiles } from "../../services/cabinetTilesService";
import css from "../catalog/catalog.module.css"; // ті самі стилі!

// нормалізація способу
const normPm = (pm) => (pm === "card" ? "acquiring" : pm || "invoice");
const pmLabel = (pm) =>
  ({ invoice: "Рахунок", acquiring: "Еквайринг" }[pm] || "—");

// t.me deep link
function tgLink(username, text) {
  if (!username) return "#";
  const u = username.replace(/^@/, "");
  return `https://t.me/${u}?text=${encodeURIComponent(text || "")}`;
}

// simple template fill
function fill(tpl = "", vars = {}) {
  return tpl.replace(/{{\s*(\w+)\s*}}/g, (_, k) => `${vars[k] ?? ""}`);
}

export default function CabinetTilesDynamic() {
  const [cfg, setCfg] = useState(null);
  const [userMeta, setUserMeta] = useState({
    paymentMethod: "invoice",
    displayName: "",
  });
  const [contractsOpen, setContractsOpen] = useState(false);

  useEffect(() => {
    const unsub = subscribeCabinetTiles(setCfg);
    return () => unsub && unsub();
  }, []);

  useEffect(() => {
    const uid = auth?.currentUser?.uid;
    if (!uid) return;
    getDoc(doc(db, "users", uid)).then((s) => {
      const d = s.data() || {};
      setUserMeta({
        paymentMethod: d.paymentMethod || "invoice", // дефолт — рахунок
        displayName: d.displayName || "",
      });
    });
  }, []);

  if (!cfg) return null;

  const pm = normPm(userMeta.paymentMethod);
  const opposite = pm === "invoice" ? "acquiring" : "invoice";
  const nameOrId =
    userMeta.displayName ||
    auth?.currentUser?.email ||
    auth?.currentUser?.uid ||
    "Клієнт";

  // Тексти і лінки — тільки з адмінки:
  const tile1Text =
    pm === "invoice" ? cfg?.tile1?.invoiceText : cfg?.tile1?.acquiringText;

  const tile2Label =
    pm === "invoice" ? cfg?.tile2?.invoiceCta : cfg?.tile2?.acquiringCta;

  const tile2Text = fill(cfg?.tile2?.template, {
    name: nameOrId,
    current: pmLabel(pm),
    desired: pmLabel(opposite),
  });
  const tile2Href = tgLink(cfg?.tile2?.telegram, tile2Text);

  const tile3Label = cfg?.tile3?.label;
  const tile3Href = tgLink(cfg?.tile3?.telegram, cfg?.tile3?.template || "");

  const tile4Label = cfg?.tile4?.label;
  const tile4Href = cfg?.tile4?.url || "#";

  const tile5Title = cfg?.tile5?.title || "Інформація";

  const hasSale = !!cfg?.contracts?.sale?.url;
  const hasCons = !!cfg?.contracts?.consignment?.url;
  const hasDrop = !!cfg?.contracts?.dropshipping?.url;
  const hasContracts = hasSale || hasCons || hasDrop;

  return (
    <div className={css.discountAndACWrapp}>
      {/* Перший ряд — 2 плашки */}
      <div className={css.discountAndACWrappFirst}>
        {/* 1) Інфо про поточний спосіб оплати */}
        <div className={css.freeDelyvery} role="button" tabIndex={0}>
          {tile1Text || `Ваш тип оплати — ${pmLabel(pm)}`}
        </div>

        {/* 2) Заявка на зміну способу */}
        <a
          className={css.procentSale}
          href={tile2Href}
          target="_blank"
          rel="noopener"
        >
          {tile2Label || `Заявка на зміну: ${pmLabel(opposite)}`}
        </a>
      </div>

      {/* Другий ряд — 3 плашки */}
      <div className={css.discountAndACWrappSecond}>
        {/* 3) Порекомендуйте видати книгу */}
        <a
          className={css.discountForNine}
          href={tile3Href}
          target="_blank"
          rel="noopener"
        >
          {tile3Label || "Порекомендуйте видати книгу"}
        </a>

        {/* 4) Скрипти продаж (YouTube) */}
        <a
          className={css.krohmalPackeg}
          href={tile4Href}
          target="_blank"
          rel="noopener"
        >
          {tile4Label || "Скрипти продаж книжок"}
        </a>

        {/* 5) Інформаційна — тільки заголовок; поп-ап на hover/click */}
        <div
          className={css.smakolukForUser}
          style={{
            position: "relative",
            cursor: hasContracts ? "pointer" : "default",
          }}
          onMouseEnter={() => hasContracts && setContractsOpen(true)}
          onMouseLeave={() => hasContracts && setContractsOpen(false)}
          onClick={() => hasContracts && setContractsOpen((v) => !v)}
          tabIndex={0}
        >
          <div style={{ fontWeight: 700 }}>{tile5Title}</div>

          {hasContracts && contractsOpen && (
            <div
              style={{
                position: "absolute",
                top: "145px",
                left: 0,
                marginTop: 8,
                zIndex: 1000,
                minWidth: 280,
                background: "#fff",
                border: "1px solid #eee",
                borderRadius: 12,
                boxShadow: "0 10px 30px rgba(0,0,0,.12)",
                padding: 12,
              }}
            >
              <div style={{ fontWeight: 700, marginBottom: 8 }}>Договори</div>
              <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 1.5 }}>
                {hasSale && (
                  <li>
                    <a
                      href={cfg.contracts.sale.url}
                      target="_blank"
                      rel="noopener"
                      style={{ textDecoration: "none" }}
                    >
                      Договір купівлі-продажу
                    </a>
                  </li>
                )}
                {hasCons && (
                  <li>
                    <a
                      href={cfg.contracts.consignment.url}
                      target="_blank"
                      rel="noopener"
                      style={{ textDecoration: "none" }}
                    >
                      Договір дропшипінгу
                    </a>
                  </li>
                )}
                {/* {hasDrop && (
                  <li>
                    <a
                      href={cfg.contracts.dropshipping.url}
                      target="_blank"
                      rel="noopener"
                      style={{ textDecoration: "none" }}
                    >
                      Договір для Дропшипінгу
                    </a>
                  </li>
                )} */}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
